import React, { useState, useMemo } from 'react';
import * as AllIcons from '../Icon';

const CATEGORY_MAP = {
    'Навигация и базовый UI': [
        'ChevronUpIcon', 'PlusIcon', 'MinusIcon', 'HomeIcon', 'CrosshairIcon',
        'SearchIcon', 'FilterIcon', 'CloseIcon', 'MenuIcon', 'CopyIcon',
        'ExternalLinkIcon', 'GlobeIcon', 'SettingsIcon', 'InfoIcon', 'ListIcon',
        'ViewIcon', 'LogoutIcon'
    ],
    'Картография и объекты': [
        'BuildingIcon', 'OfficeIcon', 'HouseIcon', 'FactoryIcon', 'LandmarkIcon',
        'PinIcon', 'RoadIcon', 'RailroadIcon', 'BoundaryIcon', 'WaterIcon',
        'ForestIcon', 'ParkIcon', 'MapIcon'
    ],
    'Инструменты и топология': [
        'DrawPolygonIcon', 'DrawLineIcon', 'DrawPointIcon', 'AddPlotIcon',
        'MoveIcon', 'RotateIcon', 'ScaleIcon', 'MergeIcon', 'SplitIcon',
        'UndoRedoIcon', 'RulerIcon', 'LayersIcon', 'EditIcon', 'TextIcon'
    ],
    'Статусы и состояния': [
        'ForSaleIcon', 'UnderConstructionIcon', 'PlannedIcon', 'CheckCircleIcon',
        'AlertTriangleIcon', 'XCircleIcon'
    ],
    'Файлы, экспорт и действия': [
        'ExportIcon', 'ImportIcon', 'SaveIcon', 'PrintIcon', 'ExcelIcon',
        'UploadIcon', 'TrashIcon', 'DeleteIcon'
    ]
};

// Примеры иконок для анатомического разбора
const ANATOMY_EXAMPLES = {
    'CloseIcon': {
        name: 'CloseIcon (Кнопка закрытия / Сброс)',
        desc: 'Круговой бейдж с открытой дугой SVG Arc (радиус 10px) и центрированным внутренним крестиком 6×6px.',
        path: (
            <path
                d="M9 9L15 15M15 9L9 15M9.5 2.4A10 10 0 1 1 2.4 9.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        ),
        rawPath: `M9 9L15 15M15 9L9 15M9.5 2.4A10 10 0 1 1 2.4 9.5`
    },
    'DrawPolygonIcon': {
        name: 'DrawPolygonIcon (Участки / Полигоны)',
        desc: 'Прямоугольный контур с выраженными круглыми узловыми вершинами (вертексами) по углам.',
        path: (
            <path d="M16 18.5C16 19.8807 17.1193 21 18.5 21C19.8807 21 21 19.8807 21 18.5C21 17.1193 19.8807 16 18.5 16M16 18.5C16 17.1193 17.1193 16 18.5 16M16 18.5H8M18.5 16V8M8 18.5C8 19.8807 6.88071 21 5.5 21C4.11929 21 3 19.8807 3 18.5C3 17.1193 4.11929 16 5.5 16M8 18.5C8 17.1193 6.88071 16 5.5 16M5.5 16V8M5.5 8C4.11929 8 3 6.88071 3 5.5C3 4.11929 4.11929 3 5.5 3C6.88071 3 8 4.11929 8 5.5M5.5 8C6.88071 8 8 6.88071 8 5.5M8 5.5H16M18.5 8C17.1193 8 16 6.88071 16 5.5M18.5 8C19.8807 8 21 6.88071 21 5.5C21 4.11929 19.8807 3 18.5 3C17.1193 3 16 4.11929 16 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        ),
        rawPath: `M16 18.5C16 19.8807 17.1193 21 18.5 21C19.8807 21 21 19.8807 21 18.5C21 17.1193 19.8807 16 18.5 16M16 18.5C16 17.1193 17.1193 16 18.5 16M16 18.5H8M18.5 16V8M8 18.5C8 19.8807 6.88071 21 5.5 21C4.11929 21 3 19.8807 3 18.5C3 17.1193 4.11929 16 5.5 16M8 18.5C8 17.1193 6.88071 16 5.5 16M5.5 16V8M5.5 8C4.11929 8 3 6.88071 3 5.5C3 4.11929 4.11929 3 5.5 3C6.88071 3 8 4.11929 8 5.5M5.5 8C6.88071 8 8 6.88071 8 5.5M8 5.5H16M18.5 8C17.1193 8 16 6.88071 16 5.5M18.5 8C19.8807 8 21 6.88071 21 5.5C21 4.11929 19.8807 3 18.5 3C17.1193 3 16 4.11929 16 5.5`
    },
    'PinIcon': {
        name: 'PinIcon (Маркер локации)',
        desc: 'Каплевидный гео-маркер высотой 20px с внутренним кольцом-ориентиром.',
        path: (
            <>
                <path d="M12 2C7.02944 2 3 6.02944 3 11C3 13.704 4.40858 16.0555 5.97592 17.8473C7.55461 19.652 9.3972 21.0075 10.4939 21.7371C11.411 22.3473 12.589 22.3473 13.5061 21.7371C14.6028 21.0075 16.4454 19.652 18.0241 17.8473C19.5914 16.0555 21 13.704 21 11C21 6.02944 16.9706 2 12 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                <path d="M12 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
            </>
        ),
        rawPath: `M12 2C7.02944 2 3 6.02944 3 11C3 13.704 4.40858 16.0555 5.97592 17.8473C7.55461 19.652 9.3972 21.0075 10.4939 21.7371C11.411 22.3473 12.589 22.3473 13.5061 21.7371C14.6028 21.0075 16.4454 19.652 18.0241 17.8473C19.5914 16.0555 21 13.704 21 11C21 6.02944 16.9706 2 12 2Z M12 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4z`
    }
};

// Функция автоматического извлечения SVG-кода из любого React-компонента иконки
export function extractIconSvgCode(IconComponent) {
    if (!IconComponent || typeof IconComponent !== 'function') return '';
    try {
        const rendered = IconComponent({});
        if (!rendered || !rendered.props) return '';

        const children = rendered.props.children;
        const renderNodeToSvg = (node) => {
            if (!node) return '';
            if (Array.isArray(node)) {
                return node.map(renderNodeToSvg).filter(Boolean).join('\n');
            }
            if (React.isValidElement(node)) {
                const type = typeof node.type === 'string' ? node.type : 'path';
                if (node.type === React.Fragment) {
                    return renderNodeToSvg(node.props?.children);
                }
                const props = node.props || {};
                const attrStrings = [];

                if (props.d) {
                    attrStrings.push(`d="${props.d}"`);
                }

                Object.entries(props).forEach(([key, val]) => {
                    if (key === 'children' || key === 'key' || key === 'ref' || key === 'd') return;
                    if (val === undefined || val === null) return;

                    let attrName = key;
                    if (key === 'strokeLinecap') attrName = 'strokeLinecap';
                    else if (key === 'strokeLinejoin') attrName = 'strokeLinejoin';
                    else if (key === 'strokeWidth') attrName = 'strokeWidth';
                    else if (key === 'strokeDasharray') attrName = 'strokeDasharray';
                    else if (key === 'fillRule') attrName = 'fillRule';
                    else if (key === 'clipRule') attrName = 'clipRule';

                    attrStrings.push(`${attrName}="${val}"`);
                });

                const inner = renderNodeToSvg(props.children);
                if (inner) {
                    return `<${type} ${attrStrings.join(' ')}>\n${inner}\n</${type}>`;
                } else {
                    return `<${type} ${attrStrings.join(' ')} />`;
                }
            }
            return '';
        };

        return renderNodeToSvg(children);
    } catch (e) {
        console.error('Failed to extract SVG from component:', e);
        return '';
    }
}

const IconShowcase = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [copiedName, setCopiedName] = useState(null);
    const [activeTab, setActiveTab] = useState('library'); // 'library' | 'studio'
    const [isSaving, setIsSaving] = useState(false);
    
    // Состояние интерактивной студии сетки
    const [selectedAnatomy, setSelectedAnatomy] = useState('CloseIcon');
    const [showKeylines, setShowKeylines] = useState(true);
    const [showSafeZone, setShowSafeZone] = useState(true);
    const [showGridLines, setShowGridLines] = useState(true);
    const [showDiagonals, setShowDiagonals] = useState(true);
    const [canvasIconColor, setCanvasIconColor] = useState('#38bdf8'); // Яркий акцентный цвет по умолчанию
    const [canvasBgTheme, setCanvasBgTheme] = useState('dark'); // 'dark' (#0f172a) | 'light' (#ffffff) | 'slate' (#f1f5f9)
    
    // Состояние песочницы SVG
    const [customSvgPath, setCustomSvgPath] = useState('');
    const [customIconName, setCustomIconName] = useState('CustomNewIcon');

    // Собираем все экспортированные иконки (кроме базовой обертки Icon)
    const allAvailableIcons = useMemo(() => {
        return Object.entries(AllIcons)
            .filter(([name, comp]) => name !== 'Icon' && name !== 'default' && typeof comp === 'function')
            .map(([name, comp]) => ({ name, component: comp }));
    }, []);

    const iconMap = useMemo(() => {
        const map = new Map();
        allAvailableIcons.forEach(item => map.set(item.name, item.component));
        return map;
    }, [allAvailableIcons]);

    // Строим категории и находим нераспределенные
    const categorizedIcons = useMemo(() => {
        const usedNames = new Set();
        const categories = [];

        Object.entries(CATEGORY_MAP).forEach(([title, names]) => {
            const icons = names
                .filter(name => iconMap.has(name))
                .map(name => {
                    usedNames.add(name);
                    return { name, component: iconMap.get(name) };
                });

            if (icons.length > 0) {
                categories.push({ title, icons });
            }
        });

        // Нераспределенные / новые иконки
        const otherIcons = allAvailableIcons.filter(item => !usedNames.has(item.name));
        if (otherIcons.length > 0) {
            categories.push({ title: 'Прочие и новые иконки', icons: otherIcons });
        }

        return categories;
    }, [allAvailableIcons, iconMap]);

    // Фильтрация по поисковому запросу
    const filteredCategories = useMemo(() => {
        if (!searchQuery.trim()) return categorizedIcons;
        const query = searchQuery.toLowerCase().trim();

        return categorizedIcons
            .map(cat => ({
                ...cat,
                icons: cat.icons.filter(i => i.name.toLowerCase().includes(query))
            }))
            .filter(cat => cat.icons.length > 0);
    }, [categorizedIcons, searchQuery]);

    const totalIconsCount = allAvailableIcons.length;

    const handleCopy = (text, label = 'Скопировано!') => {
        navigator.clipboard?.writeText(text);
        setCopiedName(label);
        setTimeout(() => setCopiedName(null), 2200);
    };

    const handleSelectIconForTester = (iconItem) => {
        const svgCode = extractIconSvgCode(iconItem.component);
        setCustomIconName(iconItem.name);
        setCustomSvgPath(svgCode);
        setActiveTab('studio');
        setCopiedName(`Иконка «${iconItem.name}» загружена в тестер!`);
        setTimeout(() => setCopiedName(null), 2500);
    };

    const handleApplyChanges = async () => {
        const name = customIconName.trim();
        if (!name || !/^[A-Z][a-zA-Z0-9]*Icon$/.test(name)) {
            alert('Пожалуйста, укажите корректное имя компонента на английском с окончанием "Icon" (например, CloseIcon, NewBuildingIcon)');
            return;
        }

        const elementsToSave = parsedCustomElements && parsedCustomElements.length > 0
            ? parsedCustomElements
            : (currentAnatomy.rawPath ? [{ d: currentAnatomy.rawPath, strokeLinecap: 'round', strokeLinejoin: 'round' }] : []);

        if (elementsToSave.length === 0) {
            alert('Пожалуйста, укажите SVG контур <path d="..." /> для иконки');
            return;
        }

        setIsSaving(true);
        try {
            const response = await fetch('/api/dev/icons/save', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name,
                    paths: elementsToSave,
                    rawPath: (elementsToSave[0] && elementsToSave[0].d) || ''
                })
            });

            const data = await response.json();
            if (!response.ok || !data.success) {
                throw new Error(data.error || 'Ошибка при сохранении иконки');
            }

            setCopiedName(`✓ Иконка <${name} /> сохранена в проект и обновлена на лету!`);
            setTimeout(() => setCopiedName(null), 3200);
        } catch (err) {
            console.error('Ошибка сохранения иконки в проект:', err);
            alert(`Не удалось сохранить иконку: ${err.message}`);
        } finally {
            setIsSaving(false);
        }
    };

    const currentAnatomy = ANATOMY_EXAMPLES[selectedAnatomy] || ANATOMY_EXAMPLES['CloseIcon'];

    // Универсальный парсер SVG: поддерживает <path ...>, <svg>...</svg>, d="..." и чистые строки координат
    const parsedCustomElements = useMemo(() => {
        if (!customSvgPath.trim()) return null;
        const input = customSvgPath.trim();

        // 1. Поиск всех тегов <path ...>
        const pathMatches = Array.from(input.matchAll(/<path\b([^>]*)\/?>/gi));
        if (pathMatches.length > 0) {
            const items = pathMatches.map((match, idx) => {
                const attrStr = match[1];
                const dMatch = attrStr.match(/d=["']([^"']+)["']/i);
                const fillMatch = attrStr.match(/fill=["']([^"']+)["']/i);
                const strokeMatch = attrStr.match(/stroke=["']([^"']+)["']/i);
                const strokeWidthMatch = attrStr.match(/stroke-?width=["']([^"']+)["']/i);

                return {
                    d: dMatch ? dMatch[1] : '',
                    fill: fillMatch ? fillMatch[1] : 'none',
                    stroke: strokeMatch ? strokeMatch[1] : 'currentColor',
                    strokeWidth: strokeWidthMatch ? strokeWidthMatch[1] : '1.5',
                    key: idx
                };
            }).filter(p => Boolean(p.d));

            if (items.length > 0) return items;
        }

        // 2. Если тегов <path> нет, но есть d="..."
        const dMatches = Array.from(input.matchAll(/d=["']([^"']+)["']/gi)).map(m => m[1]);
        if (dMatches.length > 0) {
            return dMatches.map((d, idx) => ({
                d,
                fill: 'none',
                stroke: 'currentColor',
                strokeWidth: '1.5',
                key: idx
            }));
        }

        // 3. Если это сырая строка координат d="M...":
        const cleaned = input.replace(/^["'`]|["'`]$/g, '').trim();
        if (cleaned.length > 0) {
            return [{
                d: cleaned,
                fill: 'none',
                stroke: 'currentColor',
                strokeWidth: '1.5',
                key: 0
            }];
        }

        return null;
    }, [customSvgPath]);

    // Рендер активного SVG в песочнице и на холсте сетки
    const parsedCustomPath = useMemo(() => {
        if (!parsedCustomElements || parsedCustomElements.length === 0) {
            return currentAnatomy.path;
        }
        return (
            <>
                {parsedCustomElements.map((elem, i) => (
                    <path
                        key={i}
                        d={elem.d}
                        stroke={elem.stroke || 'currentColor'}
                        strokeWidth={elem.strokeWidth || '1.5'}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill={elem.fill || 'none'}
                    />
                ))}
            </>
        );
    }, [parsedCustomElements, currentAnatomy]);

    const generatedCode = useMemo(() => {
        const name = customIconName.trim() || 'CustomIcon';

        if (parsedCustomElements && parsedCustomElements.length > 1) {
            const pathLines = parsedCustomElements
                .map(p => `        <path\n            d="${p.d}"\n            strokeLinecap="round"\n            strokeLinejoin="round"\n        />`)
                .join('\n');

            return `import React from 'react';
import Icon from './Icon';

const ${name} = (props) => (
    <Icon {...props}>
${pathLines}
    </Icon>
);

export default ${name};`;
        }

        const pathData = (parsedCustomElements && parsedCustomElements[0]?.d) || currentAnatomy.rawPath;
        return `import React from 'react';
import Icon from './Icon';

const ${name} = (props) => (
    <Icon {...props}>
        <path
            d="${pathData}"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default ${name};`;
    }, [customIconName, parsedCustomElements, currentAnatomy]);

    return (
        <div style={{ padding: '24px 32px', maxWidth: '1400px', margin: '0 auto', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
            
            {/* Всплывающее уведомление */}
            {copiedName && (
                <div style={{
                    position: 'fixed',
                    bottom: '24px',
                    right: '24px',
                    background: '#10b981',
                    color: '#ffffff',
                    padding: '12px 20px',
                    borderRadius: '8px',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
                    fontSize: '14px',
                    fontWeight: '600',
                    zIndex: 99999,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    <span>✓</span> {copiedName}
                </div>
            )}

            {/* Шапка и переключатель разделов */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px', marginBottom: '24px', borderBottom: '1px solid #e2e8f0', paddingBottom: '16px' }}>
                <div>
                    <h1 style={{ margin: '0 0 6px 0', fontSize: '26px', color: '#0f172a', fontWeight: '700' }}>
                        Дизайн-система иконок IChis SPD
                    </h1>
                    <p style={{ margin: 0, color: '#64748b', fontSize: '14px' }}>
                        Единый стандарт 24×24px • 100% актуальная база ({totalIconsCount} шт.) • Интерактивный холст сетки
                    </p>
                </div>

                <div style={{ display: 'flex', background: '#f1f5f9', padding: '4px', borderRadius: '10px', gap: '4px' }}>
                    <button
                        onClick={() => setActiveTab('library')}
                        style={{
                            padding: '8px 16px',
                            borderRadius: '6px',
                            border: 'none',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            background: activeTab === 'library' ? '#ffffff' : 'transparent',
                            color: activeTab === 'library' ? '#0f172a' : '#64748b',
                            boxShadow: activeTab === 'library' ? '0 2px 6px rgba(0,0,0,0.06)' : 'none',
                            transition: 'all 0.15s ease'
                        }}
                    >
                        Все иконки ({totalIconsCount})
                    </button>
                    <button
                        onClick={() => setActiveTab('studio')}
                        style={{
                            padding: '8px 16px',
                            borderRadius: '6px',
                            border: 'none',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            background: activeTab === 'studio' ? '#ffffff' : 'transparent',
                            color: activeTab === 'studio' ? '#2563eb' : '#64748b',
                            boxShadow: activeTab === 'studio' ? '0 2px 6px rgba(0,0,0,0.06)' : 'none',
                            transition: 'all 0.15s ease'
                        }}
                    >
                        Сетка 24×24 и CloseIcon
                    </button>
                </div>
            </div>

            {/* ВКЛАДКА 1: БИБЛИОТЕКА ИКОНОК */}
            {activeTab === 'library' && (
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', maxWidth: '380px' }}>
                            <input
                                type="text"
                                placeholder="Поиск иконки по имени..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '10px 16px',
                                    border: '1px solid #cbd5e1',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    outline: 'none',
                                    background: '#ffffff'
                                }}
                            />
                            {searchQuery && (
                                <button
                                    onClick={() => setSearchQuery('')}
                                    style={{
                                        padding: '10px 14px',
                                        background: '#f1f5f9',
                                        border: '1px solid #cbd5e1',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        fontSize: '13px'
                                    }}
                                >
                                    Сброс
                                </button>
                            )}
                        </div>
                    </div>

                    {filteredCategories.map((category, categoryIndex) => (
                        <section key={categoryIndex} style={{ marginBottom: '36px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', marginBottom: '16px' }}>
                                <h2 style={{ fontSize: '17px', fontWeight: '600', color: '#1e293b', margin: 0 }}>
                                    {category.title}
                                </h2>
                                <span style={{ fontSize: '12px', color: '#64748b', background: '#f1f5f9', padding: '2px 8px', borderRadius: '12px', fontWeight: '500' }}>
                                    {category.icons.length} шт.
                                </span>
                            </div>

                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                                gap: '12px'
                            }}>
                                {category.icons.map((iconItem, iconIndex) => {
                                    const IconComponent = iconItem.component;

                                    return (
                                        <div
                                            key={iconIndex}
                                            onClick={() => handleSelectIconForTester(iconItem)}
                                            title="Нажмите, чтобы сразу открыть и редактировать иконку в тестере сетки"
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                padding: '14px 10px',
                                                border: '1px solid #e2e8f0',
                                                borderRadius: '8px',
                                                backgroundColor: '#ffffff',
                                                transition: 'all 0.15s ease',
                                                cursor: 'pointer',
                                                boxShadow: '0 1px 2px rgba(0,0,0,0.03)'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-2px)';
                                                e.currentTarget.style.borderColor = '#2563eb';
                                                e.currentTarget.style.boxShadow = '0 6px 14px rgba(37,99,235,0.12)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.borderColor = '#e2e8f0';
                                                e.currentTarget.style.boxShadow = '0 1px 2px rgba(0,0,0,0.03)';
                                            }}
                                        >
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '46px',
                                                height: '46px',
                                                marginBottom: '8px',
                                                backgroundColor: '#f8fafc',
                                                borderRadius: '6px',
                                                color: '#334155'
                                            }}>
                                                <IconComponent size={26} strokeWidth={1.5} />
                                            </div>
                                            <code style={{
                                                fontSize: '12px',
                                                color: '#0f172a',
                                                textAlign: 'center',
                                                wordBreak: 'break-all',
                                                fontWeight: '500',
                                                marginBottom: '6px'
                                            }}>
                                                {iconItem.name}
                                            </code>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: 'auto' }}>
                                                <span style={{
                                                    fontSize: '11px',
                                                    color: '#2563eb',
                                                    background: '#eff6ff',
                                                    padding: '2px 6px',
                                                    borderRadius: '4px',
                                                    fontWeight: '600'
                                                }}>
                                                    В тестер ↗
                                                </span>
                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleCopy(`<${iconItem.name} />`, `<${iconItem.name} /> скопирован!`);
                                                    }}
                                                    title="Скопировать JSX тег"
                                                    style={{
                                                        border: '1px solid #cbd5e1',
                                                        background: '#ffffff',
                                                        borderRadius: '4px',
                                                        padding: '2px 6px',
                                                        fontSize: '11px',
                                                        cursor: 'pointer',
                                                        color: '#64748b'
                                                    }}
                                                >
                                                    Копия
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </section>
                    ))}
                </div>
            )}

            {/* ВКЛАДКА 2: ИНТЕРАКТИВНЫЙ ХОЛСТ СЕТКИ 24x24 & CLOSEICON АНАТОМИЯ */}
            {activeTab === 'studio' && (
                <div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(340px, 420px) 1fr', gap: '32px', alignItems: 'start' }}>
                        
                        {/* ЛЕВАЯ КОЛОНКА: ИНТЕРАКТИВНЫЙ ГРАФИЧЕСКИЙ ХОЛСТ 24x24 (Масштаб 16:1) */}
                        <div style={{ background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 16px rgba(0,0,0,0.05)' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                                <span style={{ fontWeight: '700', fontSize: '15px', color: '#0f172a' }}>
                                    Холст 24×24 px (Зум 1600%)
                                </span>
                                <span style={{ fontSize: '12px', color: '#64748b', background: '#f1f5f9', padding: '2px 8px', borderRadius: '4px' }}>
                                    viewBox="0 0 24 24"
                                </span>
                            </div>

                            {/* Панель управления цветом и фоном холста */}
                            <div style={{ marginBottom: '14px', display: 'flex', flexDirection: 'column', gap: '10px', background: '#f8fafc', padding: '12px 14px', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
                                {/* Выбор цвета иконки */}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px' }}>
                                    <span style={{ fontSize: '12px', fontWeight: '600', color: '#334155' }}>Цвет иконки:</span>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        {[
                                            { color: '#ffffff', label: 'Белый' },
                                            { color: '#38bdf8', label: 'Голубой' },
                                            { color: '#2563eb', label: 'Синий' },
                                            { color: '#10b981', label: 'Зеленый' },
                                            { color: '#f59e0b', label: 'Оранжевый' },
                                            { color: '#ef4444', label: 'Красный' },
                                            { color: '#0f172a', label: 'Черный' }
                                        ].map(item => (
                                            <button
                                                key={item.color}
                                                onClick={() => setCanvasIconColor(item.color)}
                                                title={item.label}
                                                style={{
                                                    width: '22px',
                                                    height: '22px',
                                                    borderRadius: '50%',
                                                    background: item.color,
                                                    border: canvasIconColor === item.color ? '2px solid #2563eb' : '1px solid #cbd5e1',
                                                    boxShadow: canvasIconColor === item.color ? '0 0 0 2px #bfdbfe' : 'none',
                                                    cursor: 'pointer',
                                                    padding: 0
                                                }}
                                            />
                                        ))}
                                        <input
                                            type="color"
                                            value={canvasIconColor}
                                            onChange={e => setCanvasIconColor(e.target.value)}
                                            title="Кастомный цвет"
                                            style={{
                                                width: '24px',
                                                height: '24px',
                                                padding: 0,
                                                border: 'none',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                                background: 'transparent'
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Выбор фона холста */}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '8px' }}>
                                    <span style={{ fontSize: '12px', fontWeight: '600', color: '#334155' }}>Фон холста:</span>
                                    <div style={{ display: 'flex', gap: '4px' }}>
                                        {[
                                            { id: 'dark', label: 'Тёмный', bg: '#0f172a' },
                                            { id: 'slate', label: 'Серый', bg: '#f1f5f9' },
                                            { id: 'light', label: 'Светлый', bg: '#ffffff' }
                                        ].map(theme => (
                                            <button
                                                key={theme.id}
                                                onClick={() => setCanvasBgTheme(theme.id)}
                                                style={{
                                                    padding: '3px 8px',
                                                    fontSize: '11px',
                                                    fontWeight: '600',
                                                    borderRadius: '4px',
                                                    border: canvasBgTheme === theme.id ? '1px solid #2563eb' : '1px solid #cbd5e1',
                                                    background: canvasBgTheme === theme.id ? '#eff6ff' : '#ffffff',
                                                    color: canvasBgTheme === theme.id ? '#1d4ed8' : '#475569',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                {theme.label}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* SVG Сетка */}
                            <div style={{
                                position: 'relative',
                                width: '384px',
                                height: '384px',
                                margin: '0 auto',
                                background: canvasBgTheme === 'dark' ? '#0f172a' : canvasBgTheme === 'slate' ? '#f1f5f9' : '#ffffff',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                border: '2px solid #cbd5e1',
                                transition: 'background 0.2s ease'
                            }}>
                                <svg width="384" height="384" viewBox="0 0 24 24" style={{ display: 'block', width: '100%', height: '100%' }}>
                                    <defs>
                                        {/* Пиксельная сетка 1x1 */}
                                        <pattern id="pixelGrid" width="1" height="1" patternUnits="userSpaceOnUse">
                                            <rect
                                                width="1"
                                                height="1"
                                                fill="none"
                                                stroke={canvasBgTheme === 'dark' ? '#1e293b' : '#e2e8f0'}
                                                strokeWidth="0.04"
                                            />
                                        </pattern>
                                    </defs>

                                    {/* Фон сетки */}
                                    {showGridLines && <rect width="24" height="24" fill="url(#pixelGrid)" />}

                                    {/* Центральные оси X / Y */}
                                    <line x1="12" y1="0" x2="12" y2="24" stroke="#38bdf8" strokeWidth="0.08" strokeDasharray="0.3,0.3" opacity={canvasBgTheme === 'dark' ? '0.6' : '0.8'} />
                                    <line x1="0" y1="12" x2="24" y2="12" stroke="#38bdf8" strokeWidth="0.08" strokeDasharray="0.3,0.3" opacity={canvasBgTheme === 'dark' ? '0.6' : '0.8'} />

                                    {/* Диагонали */}
                                    {showDiagonals && (
                                        <>
                                            <line x1="0" y1="0" x2="24" y2="24" stroke={canvasBgTheme === 'dark' ? '#475569' : '#94a3b8'} strokeWidth="0.05" strokeDasharray="0.4,0.4" />
                                            <line x1="24" y1="0" x2="0" y2="24" stroke={canvasBgTheme === 'dark' ? '#475569' : '#94a3b8'} strokeWidth="0.05" strokeDasharray="0.4,0.4" />
                                        </>
                                    )}

                                    {/* Безопасная зона: Padding 2px (Активная область 20x20) */}
                                    {showSafeZone && (
                                        <rect x="2" y="2" width="20" height="20" fill="none" stroke="#ef4444" strokeWidth="0.1" strokeDasharray="0.4,0.4" opacity="0.8" />
                                    )}

                                    {/* Базовые ключевые контуры (Keylines) */}
                                    {showKeylines && (
                                        <>
                                            {/* Окружность 20x20 */}
                                            <circle cx="12" cy="12" r="10" fill="none" stroke="#3b82f6" strokeWidth="0.08" opacity={canvasBgTheme === 'dark' ? '0.5' : '0.6'} />
                                            {/* Квадрат 18x18 со скруглением */}
                                            <rect x="3" y="3" width="18" height="18" rx="2" fill="none" stroke="#eab308" strokeWidth="0.08" opacity={canvasBgTheme === 'dark' ? '0.5' : '0.7'} />
                                            {/* Горизонтальный прямоугольник 20x15 */}
                                            <rect x="2" y="4.5" width="20" height="15" rx="2" fill="none" stroke="#10b981" strokeWidth="0.06" opacity={canvasBgTheme === 'dark' ? '0.4' : '0.6'} />
                                        </>
                                    )}

                                    {/* РЕНДЕР САМОЙ ИКОНКИ (С выбранным цветом) */}
                                    <g stroke={canvasIconColor} style={{ color: canvasIconColor }} fill="none">
                                        {parsedCustomPath}
                                    </g>
                                </svg>
                            </div>

                            {/* Переключатели слоев сетки */}
                            <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <div style={{ fontSize: '13px', fontWeight: '600', color: '#475569', marginBottom: '2px' }}>
                                    Направляющие и слои:
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                                    <label style={{ fontSize: '12px', color: '#334155', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                                        <input type="checkbox" checked={showSafeZone} onChange={e => setShowSafeZone(e.target.checked)} />
                                        🔴 Safe Zone (20×20)
                                    </label>
                                    <label style={{ fontSize: '12px', color: '#334155', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                                        <input type="checkbox" checked={showKeylines} onChange={e => setShowKeylines(e.target.checked)} />
                                        🔵 Keylines (Круг/Квадрат)
                                    </label>
                                    <label style={{ fontSize: '12px', color: '#334155', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                                        <input type="checkbox" checked={showGridLines} onChange={e => setShowGridLines(e.target.checked)} />
                                        ▫️ Пиксели (1×1 px)
                                    </label>
                                    <label style={{ fontSize: '12px', color: '#334155', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                                        <input type="checkbox" checked={showDiagonals} onChange={e => setShowDiagonals(e.target.checked)} />
                                        ✖ Диагонали и центр
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* ПРАВАЯ КОЛОНКА: РАЗБОР АНАТОМИИ И ЖИВОЙ ТЕСТЕР */}
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                            
                            {/* Выбор эталонной иконки или быстрая загрузка из базы */}
                            <div style={{ background: '#f8fafc', padding: '18px 20px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                                    <h3 style={{ margin: 0, fontSize: '16px', color: '#0f172a' }}>
                                        🎯 Выбор иконки для сетки и тестера
                                    </h3>
                                    {/* Быстрый выбор из всех иконок базы */}
                                    <select
                                        value={allAvailableIcons.some(i => i.name === customIconName) ? customIconName : ''}
                                        onChange={(e) => {
                                            const selectedName = e.target.value;
                                            if (!selectedName) return;
                                            const comp = iconMap.get(selectedName);
                                            if (comp) {
                                                const svgCode = extractIconSvgCode(comp);
                                                setCustomIconName(selectedName);
                                                setCustomSvgPath(svgCode);
                                                setCopiedName(`«${selectedName}» загружена в тестер!`);
                                                setTimeout(() => setCopiedName(null), 2000);
                                            }
                                        }}
                                        style={{
                                            padding: '6px 12px',
                                            borderRadius: '6px',
                                            border: '1px solid #cbd5e1',
                                            fontSize: '13px',
                                            background: '#ffffff',
                                            color: '#0f172a',
                                            fontWeight: '600',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <option value="">⚡ Загрузить из базы ({totalIconsCount} шт.)...</option>
                                        {allAvailableIcons.map(i => (
                                            <option key={i.name} value={i.name}>{i.name}</option>
                                        ))}
                                    </select>
                                </div>
                                
                                <p style={{ margin: '0 0 14px 0', color: '#475569', fontSize: '14px', lineHeight: '1.5' }}>
                                    {customIconName && customIconName !== 'CustomNewIcon'
                                        ? `Активная иконка: «${customIconName}». Код и контур подставлены в тестер и на сетку.`
                                        : currentAnatomy.desc}
                                </p>
                                
                                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                    <span style={{ fontSize: '12px', color: '#64748b', alignSelf: 'center', fontWeight: '500' }}>Быстрые эталоны:</span>
                                    {Object.keys(ANATOMY_EXAMPLES).map(key => (
                                        <button
                                            key={key}
                                            onClick={() => {
                                                setSelectedAnatomy(key);
                                                const comp = iconMap.get(key);
                                                if (comp) {
                                                    const svgCode = extractIconSvgCode(comp);
                                                    setCustomIconName(key);
                                                    setCustomSvgPath(svgCode);
                                                } else {
                                                    setCustomIconName(key);
                                                    setCustomSvgPath(ANATOMY_EXAMPLES[key].rawPath);
                                                }
                                            }}
                                            style={{
                                                padding: '6px 14px',
                                                borderRadius: '6px',
                                                border: customIconName === key ? '2px solid #2563eb' : '1px solid #cbd5e1',
                                                background: customIconName === key ? '#eff6ff' : '#ffffff',
                                                color: customIconName === key ? '#1d4ed8' : '#334155',
                                                fontSize: '13px',
                                                fontWeight: '600',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            {key}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* Живой предпросмотр в реальных размерах интерфейса */}
                            <div style={{ background: '#ffffff', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                                <h4 style={{ margin: '0 0 16px 0', fontSize: '15px', color: '#0f172a' }}>
                                    👁 Как иконка выглядит в реальном интерфейсе (16px, 20px, 24px, 32px, 48px)
                                </h4>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '24px', flexWrap: 'wrap', padding: '16px', background: '#f8fafc', borderRadius: '8px' }}>
                                    {[16, 20, 24, 32, 48].map(size => (
                                        <div key={size} style={{ textAlign: 'center' }}>
                                            <div style={{ width: size, height: size, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#0284c7" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                                    {parsedCustomPath}
                                                </svg>
                                            </div>
                                            <div style={{ fontSize: '11px', color: '#64748b', marginTop: '6px' }}>{size}px</div>
                                        </div>
                                    ))}
                                    {/* На темной кнопке */}
                                    <div style={{ marginLeft: 'auto', display: 'flex', gap: '10px' }}>
                                        <button style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 14px', background: '#0f172a', color: '#ffffff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '500' }}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                                {parsedCustomPath}
                                            </svg>
                                            В кнопке
                                        </button>
                                        <button style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 14px', background: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5', borderRadius: '8px', fontSize: '13px', fontWeight: '500' }}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                                {parsedCustomPath}
                                            </svg>
                                            Статус
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Интерактивный генератор компонента */}
                            <div style={{ background: '#ffffff', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                                <h4 style={{ margin: '0 0 4px 0', fontSize: '15px', color: '#0f172a' }}>
                                    Тестер собственного SVG / Path
                                </h4>
                                <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#64748b' }}>
                                    Поддерживает любой формат: тег <code>&lt;path d="..." /&gt;</code>, весь <code>&lt;svg&gt;...&lt;/svg&gt;</code>, несколько путей или просто сырую строку <code>d="..."</code>
                                </p>
                                <div style={{ display: 'flex', gap: '12px', marginBottom: '12px', flexWrap: 'wrap' }}>
                                    <input
                                        type="text"
                                        placeholder="Название компонента (например: MyCloseIcon)"
                                        value={customIconName}
                                        onChange={e => setCustomIconName(e.target.value)}
                                        style={{ width: '260px', padding: '8px 12px', border: '1px solid #cbd5e1', borderRadius: '6px', fontSize: '13px' }}
                                    />
                                    <button
                                        onClick={() => handleCopy(generatedCode, 'React-компонент скопирован в буфер!')}
                                        style={{
                                            padding: '8px 16px',
                                            background: '#2563eb',
                                            color: '#ffffff',
                                            border: 'none',
                                            borderRadius: '6px',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Скопировать готовый React JSX
                                    </button>
                                    <button
                                        onClick={handleApplyChanges}
                                        disabled={isSaving}
                                        title="Сохранить изменения прямо в файл проекта (npm run dev)"
                                        style={{
                                            padding: '8px 18px',
                                            background: isSaving ? '#6ee7b7' : '#10b981',
                                            color: '#ffffff',
                                            border: 'none',
                                            borderRadius: '6px',
                                            fontSize: '13px',
                                            fontWeight: '700',
                                            cursor: isSaving ? 'not-allowed' : 'pointer',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            boxShadow: '0 2px 8px rgba(16,185,129,0.3)',
                                            transition: 'all 0.15s ease'
                                        }}
                                    >
                                        <span>💾</span> {isSaving ? 'Сохранение...' : 'Применить изменения в проект'}
                                    </button>
                                </div>
                                <textarea
                                    placeholder={`Вставьте сюда <path d="..." />, <svg>...</svg> или строку d="..."\nНапример:\n<path d="M8 8L16 16M16 8L8 16..." stroke="currentColor" strokeWidth="1.5" />`}
                                    value={customSvgPath}
                                    onChange={e => setCustomSvgPath(e.target.value)}
                                    rows={4}
                                    style={{
                                        width: '100%',
                                        padding: '10px 12px',
                                        border: '1px solid #cbd5e1',
                                        borderRadius: '8px',
                                        fontFamily: 'monospace',
                                        fontSize: '12px',
                                        boxSizing: 'border-box',
                                        outline: 'none',
                                        background: '#f8fafc',
                                        lineHeight: '1.5'
                                    }}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

export default IconShowcase;